import { PassengerTravelDocument } from '@models/requests/passenger-update-request.model';
import { PersonEditRequest } from '@models/requests/person-edit-request.model';
import {
  EmailEditRequest,
  PersonPhoneNumberRequest,
} from '@models/requests/user-customer-create-request.model';
import { LoginResponse } from '@models/responses/login-response.model';
import { VerifyRequest } from '@models/sms-validation.model';
import { createAction, props } from '@ngrx/store';
import {
  BookingSearchResult,
  User,
  UserUpdateTravelDocumentRequest,
} from 'src/app/models/user.model';

export const enum UserActionTypes {
  getUser = '[user] GET_USER',
  getUserBookings = '[user] GET_USER_BOOKINGS',
  getUserBookingsSuccess = '[user] GET_USER_BOOKINGS_SUCCESS',
  getUserSuccess = '[user] GET_USER_SUCCESS',
  getUserIfLoggedIn = '[user] GET_USER_IF_LOGGED_IN',
  login = '[user] LOGIN',
  loginSuccess = '[user] LOGIN_SUCCESS',
  verify = '[user] VERIFY',
  verifyRequired = '[user] VERIFY_REQUIRED',
  updateContactInfo = '[user] UPDATE_CONTACT_INFO',
  updateContactInfoSuccess = '[user] UPDATE_CONTACT_INFO_SUCCESS',
  updatePersonalInfo = '[user] UPDATE_PERSONAL_INFO',
  updatePersonalInfoSuccess = '[user] UPDATE_PERSONAL_INFO_SUCCESS',
  updateTravelDocuments = '[user] UPDATE_TRAVEL_DOCUMENTS',
  updateTravelDocumentsSuccess = '[user] UPDATE_TRAVEL_DOCUMENTS_SUCCESS',
  updateTravelPreferences = '[user] UPDATE_TRAVEL_PREFERENCE',
  updateTravelPreferencesSuccess = '[user] UPDATE_TRAVEL_PREFERENCE_SUCCESS',
  resetPassword = '[user] RESET_PASSWORD',
  resetPasswordSuccess = '[user] RESET_PASSWORD_SUCCESS',
  completeResetPassword = '[user] COMPLETE_RESET_PASSWORD',
  completeResetPasswordSuccess = '[user] COMPLETE_RESET_PASSWORD_SUCCESS',
  signUp = '[user] SIGN_UP',
  signUpSuccess = '[user] SIGN_UP_SUCCESS',
}

export const userGetUser = createAction(UserActionTypes.getUser);

export const userGetUserBookings = createAction(
  UserActionTypes.getUserBookings,
);

export const userGetUserBookingsSuccess = createAction(
  UserActionTypes.getUserBookingsSuccess,
  props<{ payload: BookingSearchResult[] }>(),
);

export const userGetUserSuccess = createAction(
  UserActionTypes.getUserSuccess,
  props<{ user: User }>(),
);

export const userLogin = createAction(
  UserActionTypes.login,
  props<{
    username: string;
    password: string;
    rememberMe?: boolean;
  }>(),
);

export const userLoginSuccess = createAction(
  UserActionTypes.loginSuccess,
  props<{ user: LoginResponse }>(),
);

export const userVerify = createAction(
  UserActionTypes.verify,
  props<{
    payload: VerifyRequest;
  }>(),
);

export const userVerifyRequired = createAction(
  UserActionTypes.verifyRequired,
  props<{
    user: LoginResponse;
  }>(),
);

export const userUpdatePersonalInfo = createAction(
  UserActionTypes.updatePersonalInfo,
  props<{ payload: PersonEditRequest }>(),
);

export const userUpdatePersonalInfoSuccess = createAction(
  UserActionTypes.updatePersonalInfoSuccess,
);

export const userUpdateTravelPreferences = createAction(
  UserActionTypes.updateTravelPreferences,
  props<{ payload: PersonEditRequest }>(),
);

export const userUpdateTravelPreferencesSuccess = createAction(
  UserActionTypes.updateTravelPreferencesSuccess,
);

export const userUpdateContactInfo = createAction(
  UserActionTypes.updateContactInfo,
  props<{
    emailKey: string;
    emailUpdateRequest: EmailEditRequest;
    phoneKey: string;
    phoneUpdateRequest: PersonPhoneNumberRequest;
  }>(),
);

export const userUpdateContactInfoSuccess = createAction(
  UserActionTypes.updateContactInfoSuccess,
);

export const userUpdateTravelDocuments = createAction(
  UserActionTypes.updateTravelDocuments,
  props<{
    updateRequests: UserUpdateTravelDocumentRequest[];
    createRequests: PassengerTravelDocument[];
  }>(),
);

export const userUpdateTravelDocumentsSuccess = createAction(
  UserActionTypes.updateTravelDocumentsSuccess,
);

export const userResetPassword = createAction(
  UserActionTypes.resetPassword,
  props<{
    username: string;
  }>(),
);

export const userResetPasswordSuccess = createAction(
  UserActionTypes.resetPasswordSuccess,
);

export const userCompleteResetPassword = createAction(
  UserActionTypes.completeResetPassword,
  props<{
    newpassword: string;
    resetToken: string;
  }>(),
);

export const userCompleteResetPasswordSuccess = createAction(
  UserActionTypes.completeResetPasswordSuccess,
  props<{ user: LoginResponse }>(),
);

export const userSignUp = createAction(
  UserActionTypes.signUp,
  props<{
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
    password: string;
    gender: number;
    birthDate: string;
    receiveMarketingNotifications: boolean;
    phoneNumber: string;
  }>(),
);

export const userSignUpSuccess = createAction(
  UserActionTypes.signUpSuccess,
  props<{ user: LoginResponse }>(),
);
